/* Avirelle · Stapel-Effekt Startseite (v31, 03.10.2026) – siehe avirelle-stapel.css
   v33 (PageSpeed „erzwungener Umbruch“): erst alle Masse lesen, dann alles schreiben – und höchstens einmal pro Bild (requestAnimationFrame).
   AVIRELLE 03.10.2026 · v37 — Startphase ohne erzwungenen Umbruch (Lighthouse v36: 34 ms in lauf()):
     · erster Lauf und die Anstösse 'load' / 'avirelle:css' messen im ResizeObserver-Rückruf – der kommt NACH der Layout-Berechnung
       und VOR dem Malen desselben Bildes (gleiches Bild wie vorher per requestAnimationFrame, aber ohne Layout-Zwang).
     · --avs-top-1/2 stehen am stehenden Abschnitt selbst statt an <html> (eine Änderung an <html> lässt den Browser die Stile aller
       ~3300 Elemente neu rechnen) und werden nur geschrieben, wenn sich der Wert ändert; --avs-p ebenso.
     · Scrollen, Grössenänderung und Reiterwechsel laufen unverändert über requestAnimationFrame (Lesen-dann-Schreiben).
     Rückbau: Datei aus Theme 201768272207 (v36) zurückspielen. */
(function () {
  var PAARE = [['hero_motion', 'trenner_neuheiten', '--avs-top-1'], ['kategorien', 'sale_teaser', '--avs-top-2']];
  var html = document.documentElement, geplant = false, nl = false;
  function el(k) { return document.querySelector('#main > .shopify-section[id$="__' + k + '"]'); }
  function setze(e, k, v, leer) { if ((e.style.getPropertyValue(k) || leer) !== v) e.style.setProperty(k, v); }   // v37: nur bei Änderung schreiben
  function lauf() { geplant = false; rechne(); }
  function rechne() {
    // 1. LESEN (keine Änderung dazwischen → nur eine Layout-Berechnung)
    var kopf = document.querySelector('.shopify-section--header'), kh = kopf ? kopf.getBoundingClientRect().height : 0, vh = innerHeight;
    var m = PAARE.map(function (p) {
      var s = el(p[0]), o = el(p[1]);
      return s && o ? { s: s, var: p[2], h: s.offsetHeight, t: o.getBoundingClientRect().top } : null;
    });
    // 2. SCHREIBEN
    m.forEach(function (x) {
      if (!x) return;
      // top: der stehende Abschnitt hält, sobald seine Unterkante den Bildschirmrand erreicht – höchstens direkt unter der Kopfzeile
      setze(x.s, x.var, Math.min(kh, vh - x.h) + 'px', '0px');   // v37: am Abschnitt (CSS liest var() am selben Element), leer = 0px wie im CSS
      // Fortschritt des Überdeckens 0 … 1 (0 = darüberliegender Abschnitt am unteren Rand, 1 = stehender Abschnitt ganz bedeckt)
      var q = Math.max(0, Math.min(1, 1 - (x.t - kh) / (vh - kh)));
      setze(x.s, '--avs-p', q.toFixed(3), '0.000');   // leer = var(--avs-p, 0)
      x.s.classList.toggle('avs-tritt', q > 0.001);
      x.s.classList.toggle('avs-weg', x.t <= kh + 1);
    });
  }
  function plane() { if (!geplant) { geplant = true; requestAnimationFrame(lauf); } }
  // v37: einmal nach der nächsten Layout-Berechnung messen (frischer ResizeObserver meldet sich sofort nach dem Layout, vor dem Malen)
  function nachLayout() {
    if (!('ResizeObserver' in window)) { plane(); return; }
    if (nl) return; nl = true;
    var r = new ResizeObserver(function () { r.disconnect(); nl = false; rechne(); });
    r.observe(html);
  }
  function start() {
    if (!el('hero_motion') && !el('kategorien')) return;
    html.classList.add('avs-an');
    addEventListener('scroll', plane, { passive: true });
    addEventListener('resize', plane);
    addEventListener('load', nachLayout);
    document.addEventListener('avirelle:css', nachLayout);   // v33: Stapel-CSS kommt nicht blockierend nach
    if ('ResizeObserver' in window) {   // Höhen ändern sich (Bilder, Reiterwechsel)
      var erst = true;   // v37: der erste Bericht (gleich nach dem ersten Layout) ist der Startlauf – direkt rechnen, ohne Layout-Zwang
      var ro = new ResizeObserver(function () { if (erst) { erst = false; rechne(); } else plane(); });
      PAARE.forEach(function (p) { var s = el(p[0]); if (s) ro.observe(s); });
    } else plane();   // ohne ResizeObserver wie bis v36: erster Lauf im nächsten Bild
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
